import { Component, Input, OnInit } from '@angular/core';
import { Options } from 'humanize-duration';
import { finalize, map, Observable } from 'rxjs';
import { NotificationAlertLevel } from '../../notification-alert-level.enum';

@Component({
    selector: 'banner-notification-interdiction',
    templateUrl: './banner-notification-interdiction.component.html',
    styleUrls: ['./banner-notification-interdiction.component.scss'],
    standalone: false
})
export class BannerNotificationInterdictionComponent implements OnInit {

  notificationAlertLevel = NotificationAlertLevel

  @Input() interdictionEndDate: Date | undefined

  constructor() { }

  ngOnInit(): void {
  }

  readonly humanizeConfig: Options = {
    language: 'it',
    units: ['d', 'h', 'm', 's'],
    largest: 1,
    round: true
  }

  pipeIsComplete(obs: Observable<any>) {
    return obs.pipe(map(() => true), finalize(() => false))
  }

}
